import { memo } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, Zap } from "lucide-react";

const BUSINESS_PHONE_LINK = "tel:+33549057490";

export const EmergencySection = memo(() => (
  <section className="py-16 bg-orange-500 text-white overflow-hidden relative">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute top-0 left-0 w-40 h-40 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-60 h-60 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
    </div>
    <div className="container-custom relative">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-6">
          <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center heartbeat">
            <Zap className="h-8 w-8" />
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold mb-1">Besoin d&apos;une réparation urgente ?</h2>
            <p className="text-orange-100">Intervention rapide, même jour selon disponibilité</p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <a href={BUSINESS_PHONE_LINK}>
            <Button
              size="lg"
              className="bg-white text-orange-600 hover:bg-orange-50 h-12 px-6 font-semibold gap-2 btn-glow"
              data-testid="emergency-call-btn"
            >
              <Phone className="h-5 w-5" />
              Appeler maintenant
            </Button>
          </a>
          <Link to="/urgence">
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white/10 h-12 px-6 font-semibold"
              data-testid="emergency-page-btn"
            >
              En savoir plus
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </section>
));

EmergencySection.displayName = "EmergencySection";
